import { Platform, StyleSheet } from 'react-native';
import type { Theme } from '../../../src/theme/getTheme';
import { ARENA_WEB_HEADER_CLEARANCE } from '../../../src/challenges/constants/challenges.constants';
import { HOME_COLUMN_MAX_WIDTH } from '../../../src/home/constants/home.constants';

/** Room for the tab bar + create dome + Warmup FAB below the last row. */
const HOME_SCROLL_BOTTOM_PADDING = 160;

export const getHomeScreenStyles = (theme: Theme) =>
  StyleSheet.create({
    screen: {
      flex: 1,
      backgroundColor: theme.background.primary,
      ...(Platform.OS === 'web' && {
        height: '100vh' as never,
        overflow: 'hidden' as never,
      }),
    },
    // The shared header is position:absolute on web (see _challengesLayout.styles); clear it once here.
    body: {
      flex: 1,
      ...(Platform.OS === 'web' && { paddingTop: ARENA_WEB_HEADER_CLEARANCE }),
    },
    scroll: {
      flex: 1,
    },
    scrollContent: {
      paddingHorizontal: 16,
      paddingTop: 4,
      paddingBottom: HOME_SCROLL_BOTTOM_PADDING,
    },
    // Design authored at 402pt; wide web gets a centred column rather than stretched cards (§7).
    column: {
      width: '100%',
      maxWidth: HOME_COLUMN_MAX_WIDTH,
      alignSelf: 'center',
      gap: 12,
    },
    row: {
      flexDirection: 'row',
      alignItems: 'stretch',
      gap: 10,
    },
    rowItem: {
      flex: 1,
      minWidth: 0,
    },
  });
